"use client";

import { ComponentType, useEffect, useRef, useState } from "react";

import { Skeleton } from "@/components/ui/Skeleton";

function DemoPlaceholder() {
  return (
    <Skeleton
      className="aspect-[4/3] w-full rounded-2xl sm:aspect-video"
      aria-label="Načítání ukázky"
    />
  );
}

export default function LazyDemo() {
  const containerRef = useRef<HTMLDivElement>(null);
  const [Demo, setDemo] = useState<ComponentType | null>(null);

  useEffect(() => {
    const container = containerRef.current;
    if (!container || !("IntersectionObserver" in window)) {
      void import("@/components/index/sections/Demo").then((module) => {
        setDemo(() => module.default);
      });
      return;
    }

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          void import("@/components/index/sections/Demo").then((module) => {
            setDemo(() => module.default);
          });
          observer.disconnect();
        }
      },
      { rootMargin: "400px 0px" },
    );

    observer.observe(container);
    return () => observer.disconnect();
  }, []);

  return (
    <div ref={containerRef}>{Demo ? <Demo /> : <DemoPlaceholder />}</div>
  );
}
